import React from "react";
import {IDocument} from "../../../core/interfaces/document";
import When from "../../../components/When";
import {Col, Row} from "react-bootstrap";
import {useAcceptModalContext} from "../../../providers/AcceptModalProvider";
import {useGetDocumentVersions} from "../../../api/DocumentApi";
import {Link, useLocation, useParams} from "react-router-dom";
import LoadingSpinner from "../../../components/LoadingSpinner";
import {CustomDropdownItem} from "../../../components/CustomDropdown/CustomDropdownItem/CustomDropdownItem";
import {Icon} from "../../../assets/Icons/IconClassNames";
import {useAppDispatch} from "../../../store/hooks";
import {addToast} from "../../../store/slices/uiSlice";
import {toastInfo} from "../../../core/helpers/toastHelper";

const VersionModalBody = ({
                              document,
                              cId,
                              closeFunction
                          }: { document: IDocument, cId: string, closeFunction: () => void }) => {

    const [data, isFetching] = useGetDocumentVersions(cId!, document.id, document.baseDocumentId ?? document.id);

    return (
        <When condition={!isFetching} otherwise={<LoadingSpinner/>}>
            <When condition={data.length > 0} otherwise={"Det finns inga läskvitton"}>
                {data.map(v => {
                    return <Link state={{fromVersion: true}} to={`c/${cId}/documents/${v.id}`} key={v.id}
                                 onClick={() => closeFunction()}>
                        <Row>
                            <Col>{v.name}</Col>
                            <Col>Version {v.version}
                            </Col>
                        </Row>
                    </Link>
                })}
            </When>
        </When>
    )
}
export const Versions = ({document, isEditMode}: { document: IDocument, isEditMode: boolean }) => {
    const dispatch = useAppDispatch();
    const acceptModalContext = useAcceptModalContext();
    const {cId} = useParams();
    const location = useLocation();

    const handleVersions = () => {
        if (isEditMode) {
            dispatch(addToast(toastInfo("Lämna redigeringsläge", "Vänligen lämna redigeringsläget.")));
            return;
        }
        acceptModalContext.open({
            header: "Versioner",
            declineButtonText: 'Stäng',
            body: <VersionModalBody document={document} cId={cId!}
                                    closeFunction={acceptModalContext.close}/>,
            hideAcceptButton: true,
        })
    }

    return <CustomDropdownItem
        icon={Icon.CODE_COMPARE}
        text={"Versioner"}
        disabled={!(!!document.baseDocumentId || location?.state?.fromVersion)}
        onClick={handleVersions}/>


}